import { themeExports } from "../constants/colorConstants.js";
import { useSelector, useDispatch } from "react-redux";
import { actions as systemActions } from "../store/slices/systemSlice.js";
import BaseDropdown2 from "../baseComponents/baseDropdown2.js";

const ThemeSelector = ({ style = {}, havePadding = true }) => {
  //constants
  const dispatch = useDispatch();

  //redux states
  const curentTheme = useSelector((state) => state.systemState.theme);
  const vCurrentTheme = themeExports.find(
    (theme) => theme.theme === curentTheme
  );

  //handlinFunctions
  const handleClick = (pTheme) => {
    dispatch(systemActions.setSystemTheme({ theme: pTheme }));
  };

  if (themeExports.length === 1) {
    return;
  }

  return (
    <>
      <BaseDropdown2
        value={vCurrentTheme?.name}
        style={{ paddingBottom: "2px", ...style }}
        onChange={(value) => {
          handleClick(value);
        }}
        elements={themeExports.map((theme) => {
          return {
            value: theme?.theme,
            name: theme?.name,
            isCurrent: theme?.theme === curentTheme,
          };
        })}
        hasFormWrapper={false}
        containerStyle={{ margin: "0px" }}
      />
    </>
  );
};

export default ThemeSelector;
